import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAxios } from "hooks";
import { initialValues } from "./components";
import { useSelector } from "react-redux";
import { Screen } from "./components";
import { ROUTE_EQUIPMENTS } from "const";
import { getAbsLink } from "utilities";

const EquipmentsAdd = () => {
  const navigate = useNavigate();

  const navigateToList = () => {
    navigate(getAbsLink(ROUTE_EQUIPMENTS));
  }

  // TODO: Change type any after redo auth
  const { user: { client: { clnt } } } = useSelector((state: any) => state.user);

  // Add clnt to initial values. Server throw error if no clnt
  initialValues.clnt = clnt;

  let equipmentAll = {equipment: initialValues, equipmentCols: [], equipmentSels: [], materialList: []};

  // Define save form handler
  const [post, { data: saveSuccess, loading: loadingSave }] = useAxios({
    method: "post",
    url: "/api/equipment",
    notify: true
  });

  const handleSave = (data: any) => {
    post(data);
  }

  // Save Success
  useEffect(() => {
    if (saveSuccess) {
      // 
      navigateToList();
    };
  }, [saveSuccess]);

  return (
    <Screen
      data={equipmentAll}
      handleSave={handleSave}
      handleNavigate={navigateToList}
      loadingSave={loadingSave}
    />
  );
};

export default EquipmentsAdd;
